<template>
  <div name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container d-flex flex-column h-full">
          <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
          >
          </TopAppBar>
          <div class="flex-grow-1 scroll-y">
            <div class="pda-default">
              <div class="t-subtitle2">
                {{ $t('S10072') }}
              </div>

              <div class="mgt-16">
                <div :class="{'mdc-select--disabled': defaultTerm}" class="mdc-select mdc-select--outlined w-full" id="selectNation">
                  <i class="mdc-select__dropdown-icon select-icon-custom"></i>
                  <select v-if="defaultTerm" class="mdc-select__native-control" name="terms" v-model="termsUrlIframe">
                    <option selected disabled value="">
                      {{ $moment(this.baseDate).format('L') }}
                    </option>
                  </select>
                  <select v-else class="mdc-select__native-control" name="terms" v-model="termsUrlIframe" @change="onChanged($event)">
                    <option selected disabled value="">
                      {{ $moment(this.baseDate).format('L') }}
                    </option>
                    <option v-for="(terms, index) in termsList" :key="index" :value="terms.attachment.resourceUri">
                      {{ $moment(terms.baseDate).format('L') }}
                    </option>
                  </select>
                  <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                  </div>
                </div>
              </div>
              <div class="divider mgt-24"></div>
              <div class="mgt-24 flex-grow-1 h-full">
                  <div
                      class="t-body3 t-color-content1"
                      v-html="htmlTermsOfService"
                  ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 이용약관 컴포넌트(terms and use Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import TopAppBar from "@/components/TopAppBar.vue";
import joinApi from "@/api/joinApi.js";

export default {
  components: {
    TopAppBar,
  },

  data() {
    return {
      title: this.$t("1605"),
      defaultTerm: false,
      baseDate: new Date(),
      termsList: [],
      termsUrlIframe: '',
      htmlTermsOfService: null,
    };
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.setTopAppBarCloseOnly(this.title);
    this.fetchData();
  },

  methods: {
    fetchData() {
      joinApi.termsList().then((response) => {
        this.termsList = response.data.data.TERMS_OF_SERVICE;
        this.htmlTermsOfService = this.termsList[0].attachment.resourceUri;
        this.baseDate = this.termsList[0].baseDate;

        if(this.termsList.length <= 1) {
          this.defaultTerm = true;
        }

        this.fetchContent(this.htmlTermsOfService);
      })
    },

    fetchContent(data) {
      joinApi.policyContents(data, "text").then((response) => {
        this.htmlTermsOfService = response.data;
      });
    },

    onChanged() {
      const termsUrl = event.target.value;
      this.fetchContent(termsUrl);
    }
  }
};
</script>
